(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8625],{

/***/ 51541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _data_press_items_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48379);
/* harmony import */ var _components_landing_Press__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71723);
/* harmony import */ var _components_landing_Head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81519);
/* harmony import */ var _components_landing_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94964);
/* harmony import */ var _data_seo_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35546);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);







var PRESSWIRE_DATA = _data_press_items_json__WEBPACK_IMPORTED_MODULE_0__.find(function (i) {
  return i.name === "presswire-bitcoin";
});

function PressWireBitcoin() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_landing_Head__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      SEO: _data_seo_json__WEBPACK_IMPORTED_MODULE_4__
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_landing_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_components_landing_Press__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        item: PRESSWIRE_DATA,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt merchants, partners and their customers can now engage in transactions using the world\u2019s first and best-known decentralized digital currency."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "OAKLAND, CA, US, April 5, 2022 -- Data Mynt, a leading provider of simple, stable cryptocurrency payment products, now enables payments over the Bitcoin network, which already supports roughly 225,000 transactions per day and $30 billion USD dollar equivalent volume per day worldwide (as of publishing)."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: "flex items-center space-x-8",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("svg", {
              width: "93",
              height: "68",
              viewBox: "0 0 93 68",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("g", {
                opacity: "0.3",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
                  d: "M35.4316 0L39.7465 8.855C28.3005 13.363 24.6063 22.9233 24.19 27.14C32.29 28.6733 46.923 36.041 40.655 53.245C34.3869 70.449 17.9824 68.0033 10.5637 64.63C5.3782 62.3683 -3.67566 52.624 1.59314 31.74C6.86194 10.856 26.3474 1.87833 35.4316 0Z",
                  fill: "#3D8ECD"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("path", {
                  d: "M86.2577 0L90.5727 8.855C79.1267 13.363 75.4325 22.9233 75.0161 27.14C83.1161 28.6733 97.7492 36.041 91.4811 53.245C85.2131 70.449 68.8086 68.0033 61.3899 64.63C56.2044 62.3683 47.1505 52.624 52.4193 31.74C57.6881 10.856 77.1736 1.87833 86.2577 0Z",
                  fill: "#3D8ECD"
                })]
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            className: "text-gray-50",
            children: "\u201C25% of Americans own BTC and countries like Brazil, Indonesia, Israel, India, Mexico, and South Africa have higher adoption. Our merchants feel good knowing they offer BTC owners this payment option.\u201D \u2014 Alex Christian, Data Mynt CEO"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt merchants and partners join the 15,000 retailers that accept Bitcoin today, making it the world\u2019s most widely used digital asset for payments. Retailers include Twitter, Home Depot, Whole Foods and Overstock.com."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "The Data Mynt payment processing solution enables merchants and enterprises to expand their payment options for their customers and partners. At the same time, it reduces payment processing costs and eliminates frictions such as chargebacks and crypto price volatility."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "\u201CAs a payment processor, it only makes sense for us to enable our merchants and partners to accept what the world already accepts\u2014the biggest cryptocurrency,\u201D noted Data Mynt CEO Alex Christian. Almost one-quarter of the US population owns Bitcoin. Many other countries such as Brazil, Indonesia, UAE, Singapore, Israel, India, Mexico, and South Africa have even higher adoption rates. Data Mynt merchants can feel good knowing they offer these Bitcoin owners another payment option."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h6", {
          className: "text-black text-md",
          children: "About DataMynt"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: "text-gray-50",
          children: "Data Mynt is a crypto payment processor based in Oakland, California. Its wallet, asset and blockchain-agnostic solutions offer partners and merchants an omnichannel approach to accepting crypto payments free from volatility and the risks and costs of traditional payment methods. The Data Mynt payment platform is also designed to streamline implementation via API, branded web page, iFrame and merchant app, while consistently delivering a seamless customer experience. DataMynt.com"
        })]
      })
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (PressWireBitcoin);

/***/ }),

/***/ 97679:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/presswire-bitcoin",
      function () {
        return __webpack_require__(51541);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,2834,7965,4964,169,6111,9774,2888,179], function() { return __webpack_exec__(97679); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);